"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var EnvironmentUrl = {
  DEVELOPMENT: {
    V1_STATION_ENDPOINT: 'https://ppsch.apiairasia.com/station/{0}/file.json',
    HOTEL_SUGGESTIONS_ENDPOINT: 'https://hotels.dev-apiairasia.com/smartfill/v2/smartfill?language={1}&query={0}',
    HOTEL_SUGGESTION_ENDPOINT: 'https://hotels.dev-apiairasia.com/smartfill/v2/smartfill/{0}?language={1}',
    HOTELS_SSR_DATA_URL: 'https://hotels.dev-apiairasia.com/hotelsa/getssrdata',
    NEAREST_AIRPORT_ENDPOINT: 'https://t.airasia.com/nearestairport/airport/user',
    V1_DESTINATION_ENDPOINT: 'https://ppsch.apiairasia.com/destination/{0}/file.json',
    SHARED_COMPONENT: 'https://ppsch.apiairasia.com/sharedcomponent/search/{0}/file.json',
    PRODUCT_TILES: 'https://ppsch.apiairasia.com/sharedcomponent/producttilesv2/{0}/file.json',
    AA_BASE_URL: "https://www.devairasia.com/",
    AA_FLIGHT_SEARCH_PATH_PARAMETERS: "snap/select/{locale}/{origin}/{destination}/{departureDate}/{returnDate}/{adult}/{child}/{infant}/{tripType}/{promoCode}/{currency}/{sortType}",
    // Post MVP only countryCode=MY
    AA_HOTEL_SEARCH_PATH_PARAMETERS: "hotel/search?destination={destination}&fromDate={checkinDate}&toDate={checkoutDate}&adults={adult}&children={child}&languageId={locale}&currency={currency}&countryCode=MY",
    AA_MULTI_CITY_URL: 'https://flybeyond.airasia.com/en/multicity/results/KUL~DMK/DMK~HKT/HKT~KUL',
    LFC_PRICE_ENDPOINT: {
      WEB: 'https://k.dev-apiairasia.com/availabledates-s/api/v1/pricecalendar/{0}/{1}/{2}/{3}/{4}/{5}/{6}/{7}',
      MOBILE: 'https://k.dev-apiairasia.com/availabledates-mobile/api/v1/pricecalendar/{0}/{1}/{2}/{3}/{4}/{5}/{6}/{7}'
    },
    DATA_FORMAT: {
      DATE: 'https://ppsch.apiairasia.com/dataformat/date/{0}/file.json',
      CURRENCY: 'https://sch.apiairasia.com/dataformat/currency/{0}/file.json'
    },
    BASE_CURRENCY: 'https://k.dev-apiairasia.com/basecurrency/{0}',
    MULTI_CURRENCY: 'https://k.dev-apiairasia.com/multicurrency/{0}',
    SEARCH_DEEP_LINK: 'https://k.dev-apiairasia.com/deeplink/encryptdeeplink',
    GCS_URL: 'https://ppsch.apiairasia.com/',
    SSR_URL: 'https://k.dev-apiairasia.com/',
    SSR_DATA_PATH: 'ssr/getssrdata',
    CHANNEL: "https://ppsch.apiairasia.com/channel/file.json",
    SNAP_AOC: "https://ppsch.apiairasia.com/snap/countries/file.json",
    FEATURE_FLAG: "https://ppsch.apiairasia.com/featureflags/configuration/dev/file.json",
    HOTEL_CONFIG: "https://ppsch.apiairasia.com/hotel/config/data/file.json",
    HOTEL_MOBILE_BANNER: "https://static.airasia.com/hotels/search-widget-banner/Search-Banner-Hotels-Mobile.jpg",
    HOTEL_ACCESS_TOKEN: "https://hotels.dev-apiairasia.com/hotelsa/access_token"
  },
  STAGING: {
    V1_STATION_ENDPOINT: 'https://ppsch.apiairasia.com/station/{0}/file.json',
    HOTEL_SUGGESTIONS_ENDPOINT: 'https://hotelsbe.stg-apiairasia.com/smartfill/v2/smartfill?language={1}&query={0}',
    HOTEL_SUGGESTION_ENDPOINT: 'https://hotelsbe.stg-apiairasia.com/smartfill/v2/smartfill/{0}?language={1}',
    HOTELS_SSR_DATA_URL: 'https://hotels.stg-apiairasia.com/hotelsa/getssrdata',
    NEAREST_AIRPORT_ENDPOINT: 'https://t.airasia.com/nearestairport/airport/user',
    V1_DESTINATION_ENDPOINT: 'https://ppsch.apiairasia.com/destination/{0}/file.json',
    SHARED_COMPONENT: 'https://ppsch.apiairasia.com/sharedcomponent/search/{0}/file.json',
    PRODUCT_TILES: 'https://ppsch.apiairasia.com/sharedcomponent/producttilesv2/{0}/file.json',
    AA_BASE_URL: "https://www.stgairasia.com/",
    AA_FLIGHT_SEARCH_PATH_PARAMETERS: "snap/select/{locale}/{origin}/{destination}/{departureDate}/{returnDate}/{adult}/{child}/{infant}/{tripType}/{promoCode}/{currency}/{sortType}",
    // Post MVP only countryCode=MY
    AA_HOTEL_SEARCH_PATH_PARAMETERS: "hotel/search?destination={destination}&fromDate={checkinDate}&toDate={checkoutDate}&adults={adult}&children={child}&languageId={locale}&currency={currency}&countryCode=MY",
    AA_MULTI_CITY_URL: 'https://flybeyond.airasia.com/en/multicity/results/KUL~DMK/DMK~HKT/HKT~KUL',
    LFC_PRICE_ENDPOINT: {
      WEB: 'https://k.stg-apiairasia.com/availabledates-s/api/v1/pricecalendar/{0}/{1}/{2}/{3}/{4}/{5}/{6}/{7}',
      MOBILE: 'https://k.stg-apiairasia.com/availabledates-mobile/api/v1/pricecalendar/{0}/{1}/{2}/{3}/{4}/{5}/{6}/{7}'
    },
    DATA_FORMAT: {
      DATE: 'https://ppsch.apiairasia.com/dataformat/date/{0}/file.json',
      CURRENCY: 'https://sch.apiairasia.com/dataformat/currency/{0}/file.json'
    },
    BASE_CURRENCY: 'https://k.stg-apiairasia.com/basecurrency/{0}',
    MULTI_CURRENCY: 'https://k.stg-apiairasia.com/multicurrency/{0}',
    SEARCH_DEEP_LINK: 'https://k.stg-apiairasia.com/deeplink/encryptdeeplink',
    GCS_URL: 'https://ppsch.apiairasia.com/',
    SSR_URL: 'https://k.dev-apiairasia.com/',
    SSR_DATA_PATH: 'ssr/getssrdata',
    CHANNEL: "https://ppsch.apiairasia.com/channel/file.json",
    SNAP_AOC: "https://ppsch.apiairasia.com/snap/countries/file.json",
    FEATURE_FLAG: "https://ppsch.apiairasia.com/featureflags/configuration/staging/file.json",
    HOTEL_CONFIG: "https://ppsch.apiairasia.com/hotel/config/data/file.json",
    HOTEL_MOBILE_BANNER: "https://static.airasia.com/hotels/search-widget-banner/Search-Banner-Hotels-Mobile.jpg",
    HOTEL_ACCESS_TOKEN: "https://hotels.stg-apiairasia.com/hotelsa/access_token"
  },
  PRODUCTION: {
    V1_STATION_ENDPOINT: 'https://sch.apiairasia.com/station/{0}/file.json',
    HOTEL_SUGGESTIONS_ENDPOINT: 'https://hotelsbe.apiairasia.com/smartfill/v2/smartfill?language={1}&query={0}',
    HOTEL_SUGGESTION_ENDPOINT: 'https://hotelsbe.apiairasia.com/smartfill/v2/smartfill/{0}?language={1}',
    HOTELS_SSR_DATA_URL: 'https://hotels.apiairasia.com/hotelsa/getssrdata',
    NEAREST_AIRPORT_ENDPOINT: 'https://t.airasia.com/nearestairport/airport/user',
    V1_DESTINATION_ENDPOINT: 'https://sch.apiairasia.com/destination/{0}/file.json',
    SHARED_COMPONENT: 'https://sch.apiairasia.com/sharedcomponent/search/{0}/file.json',
    PRODUCT_TILES: 'https://sch.apiairasia.com/sharedcomponent/producttilesv2/{0}/file.json',
    AA_BASE_URL: "https://www.airasia.com/",
    AA_FLIGHT_SEARCH_PATH_PARAMETERS: "snap/select/{locale}/{origin}/{destination}/{departureDate}/{returnDate}/{adult}/{child}/{infant}/{tripType}/{promoCode}/{currency}/{sortType}",
    // Post MVP only countryCode=MY
    AA_HOTEL_SEARCH_PATH_PARAMETERS: "hotel/search?destination={destination}&fromDate={checkinDate}&toDate={checkoutDate}&adults={adult}&children={child}&languageId={locale}&currency={currency}&countryCode=MY",
    LFC_PRICE_ENDPOINT: {
      WEB: 'https://k.airasia.com/availabledates-s/api/v1/pricecalendar/{0}/{1}/{2}/{3}/{4}/{5}/{6}/{7}',
      MOBILE: 'https://k.airasia.com/availabledates-mobile/api/v1/pricecalendar/{0}/{1}/{2}/{3}/{4}/{5}/{6}/{7}'
    },
    DATA_FORMAT: {
      DATE: 'https://sch.apiairasia.com/dataformat/date/{0}/file.json',
      CURRENCY: 'https://sch.apiairasia.com/dataformat/currency/{0}/file.json'
    },
    BASE_CURRENCY: 'https://k.airasia.com/basecurrency/{0}',
    MULTI_CURRENCY: 'https://k.airasia.com/multicurrency/{0}',
    SEARCH_DEEP_LINK: 'https://k.airasia.com/deeplink/encryptdeeplink',
    GCS_URL: 'https://sch.apiairasia.com/',
    SSR_URL: 'https://k.airasia.com/',
    SSR_DATA_PATH: 'ssr/getssrdata',
    CHANNEL: "https://sch.apiairasia.com/channel/file.json",
    SNAP_AOC: "https://sch.apiairasia.com/snap/countries/file.json",
    FEATURE_FLAG: "https://sch.apiairasia.com/featureflags/configuration/production/file.json",
    HOTEL_CONFIG: "https://sch.apiairasia.com/hotel/config/data/file.json",
    HOTEL_MOBILE_BANNER: "https://static.airasia.com/hotels/search-widget-banner/Search-Banner-Hotels-Mobile.jpg",
    HOTEL_ACCESS_TOKEN: "https://hotels.apiairasia.com/hotelsa/access_token"
  },
  PRE_PRODUCTION: {
    V1_STATION_ENDPOINT: 'https://sch.apiairasia.com/station/{0}/file.json',
    HOTEL_SUGGESTIONS_ENDPOINT: 'https://hotelsbe.preprod-apiairasia.com/smartfill/v2/smartfill?language={1}&query={0}',
    HOTEL_SUGGESTION_ENDPOINT: 'https://hotelsbe.preprod-apiairasia.com/smartfill/v2/smartfill/{0}?language={1}',
    HOTELS_SSR_DATA_URL: 'https://k.preprod-apiairasia.com/hotelsa/getssrdata',
    NEAREST_AIRPORT_ENDPOINT: 'https://t.airasia.com/nearestairport/airport/user',
    V1_DESTINATION_ENDPOINT: 'https://sch.apiairasia.com/destination/{0}/file.json',
    SHARED_COMPONENT: 'https://sch.apiairasia.com/sharedcomponent/search/{0}/file.json',
    PRODUCT_TILES: 'https://sch.apiairasia.com/sharedcomponent/producttilesv2/{0}/file.json',
    AA_BASE_URL: "https://ppselect.airasia.com/",
    AA_FLIGHT_SEARCH_PATH_PARAMETERS: "snap/select/{locale}/{origin}/{destination}/{departureDate}/{returnDate}/{adult}/{child}/{infant}/{tripType}/{promoCode}/{currency}/{sortType}",
    // Post MVP only countryCode=MY
    AA_HOTEL_SEARCH_PATH_PARAMETERS: "hotel/search?destination={destination}&fromDate={checkinDate}&toDate={checkoutDate}&adults={adult}&children={child}&languageId={locale}&currency={currency}&countryCode=MY",
    LFC_PRICE_ENDPOINT: {
      WEB: 'https://k.preprod-apiairasia.com/availabledates-s/api/v1/pricecalendar/{0}/{1}/{2}/{3}/{4}/{5}/{6}/{7}',
      MOBILE: 'https://k.preprod-apiairasia.com/availabledates-mobile/api/v1/pricecalendar/{0}/{1}/{2}/{3}/{4}/{5}/{6}/{7}'
    },
    DATA_FORMAT: {
      DATE: 'https://sch.apiairasia.com/dataformat/date/{0}/file.json',
      CURRENCY: 'https://sch.apiairasia.com/dataformat/currency/{0}/file.json'
    },
    BASE_CURRENCY: 'https://k.preprod-apiairasia.com/basecurrency/{0}',
    MULTI_CURRENCY: 'https://k.preprod-apiairasia.com/multicurrency/{0}',
    SEARCH_DEEP_LINK: 'https://k.preprod-apiairasia.com/deeplink/encryptdeeplink',
    GCS_URL: 'https://sch.apiairasia.com/',
    SSR_URL: 'https://k.preprod-apiairasia.com/',
    SSR_DATA_PATH: 'ssr/getssrdata',
    CHANNEL: "https://sch.apiairasia.com/channel/file.json",
    SNAP_AOC: "https://sch.apiairasia.com/snap/countries/file.json",
    FEATURE_FLAG: "https://sch.apiairasia.com/featureflags/configuration/preprod/file.json",
    HOTEL_CONFIG: "https://sch.apiairasia.com/hotel/config/data/file.json",
    HOTEL_MOBILE_BANNER: "https://static.airasia.com/hotels/search-widget-banner/Search-Banner-Hotels-Mobile.jpg",
    HOTEL_ACCESS_TOKEN: "https://hotels.apiairasia.com/hotelsa/access_token"
  }
};
var _default = EnvironmentUrl;
exports["default"] = _default;